import Vue from "vue";
import store from "@/store";
import Router from "vue-router";
import helpers from '@/services/helpers'
import check from "@/services/check-auth";
import AuthLayout from "@/layout/AuthLayout";
import appLayout from "@/layout/Ecommerce/appLayout";

import DashboardLayout from "@/layout/DashboardLayout";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router);
const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: "/",
  routes: [
    {
      path: "",
      redirect: "dashboard",
      component: appLayout,
      // component: DashboardLayout,
      children: [
        // {
        //   path: "/ecommerce",
        //   name: "ecommerce",

        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/Product/home")
        // },
        {
          path: "/terms-of-service",
          name: "terms-of-service",

          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Conditions/show_term_condition")
        },
        // {
        //   path: "/ecommerce/companies",
        //   name: "ecommerce_companies",

        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/Company")
        // },
        // {
        //   path: "/ecommerce/company/:id",
        //   name: "ecommerce_company",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/Company/company"),
        //   meta: {
        //     breadcrumb: [
        //       {
        //         text: "company",
        //         active: true
        //       }
        //     ]
        //   }
        // },
        // {
        //   path: "/ecommerce/products/:id",
        //   name: "ecommerce_products",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/Product/products"),
        //   meta: {
        //     breadcrumb: [
        //       {
        //         text: "company",
        //         back: "show_product"
        //       },
        //       {
        //         text: "show_product",
        //         active: true
        //       }
        //     ]
        //   }
        // },
        // {
        //   path: "/ecommerce/cart",
        //   name: "ecommerce_card",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/card"),
        //   meta: {
        //     breadcrumb: [
        //       {
        //         text: "cart",
        //         back: "cart"
        //       },
        //       {
        //         text: "cart",
        //         active: true
        //       }
        //     ]
        //   }
        // },
        {
          path: "/download-app",
          name: "download-app",

          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/DownloadApp")
        },

        // {
        //   path: "/payment/return",
        //   name: "payment-return",

        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "@/views/Ecommerce/Payments/payment_return")
        // },
      ]
    },
    {
      path: "",
      redirect: "dashboard",
      component: DashboardLayout,
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { requiresAuth: true },
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/BackOffice/index.vue")
        },
        {
          path: "/u/referrer/:ref",
          name: "referrals",
          meta: { requiresAuth: true },
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Profile/MyReferrals")
        },
        {
          path: "/profile",
          name: "profile",
          meta: { requiresAuth: true },
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Profile/UserProfile.vue")
        },

        // COMPANY TABLE
        {
          path: "/companies",
          name: "companies",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "companies",
                active: true
              }
            ]
          },
          component: () => import("@/views/Company")
        },
        // COMPANY CREATED
        {
          path: "/companies-create",
          name: "create_company",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "companies"
              },
              {
                text: "create_company",
                active: true
              }
            ]
          },
          component: () => import("@/views/Company/Created.vue")
        },
        // Company edit
        {
          path: "/companies-edit/:id",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          name: "edit_company",
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "companies"
              },
              {
                text: "edit_company",
                active: true
              }
            ]
          },
          props: true,
          component: () => import("@/views/Company/Edit.vue")
        },
        // SHOW COMPANY
        {
          path: "/companies-show/:id",
          name: "show_company",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "companies"
              },
              {
                text: "show_company",
                active: true
              }
            ]
          },
          props: true,
          component: () => import("@/views/Company/Show.vue")
        },
        {
          path: "/companies/term-and-conditions/:id",
          name: "term_condition_by_company",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "companies"
              },
              {
                text: "term_and_condition",
                active: true
              }
            ]
          },
          props: true,
          component: () => import("@/views/Conditions/company_term_condition")
        },
        {
          path: "/categories",
          name: "categories",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          component: () => import("@/views/BackOffice/Categories")
        },
        {
          path: "/visits",
          name: "visits",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          component: () => import("@/views/BackOffice/Visits")
        },
        {
          path: "/products",
          name: "products",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          component: () => import("@/views/BackOffice/Products")
        },
        {
          path: "/products/:id",
          name: "products_show",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          component: () => import("@/views/BackOffice/Products/show.vue")
        },
        {
          path: "/products-create/:id",
          name: "create_products",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          component: () => import("@/views/BackOffice/Products/create.vue")
        },
        {
          path: "/products-edit/:id",
          name: "edit_product",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: { requiresAuth: true },
          props: true,
          component: () => import("@/views/BackOffice/Products/edit.vue")
        },
        {
          path: "/rewards",
          name: "rewards",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          component: () => import("@/views/BackOffice/UserReward"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "rewards",
                active: true
              }
            ]
          }
        },
        {
          path: "/settings",
          name: "settings",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          component: () => import("@/views/Settings"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "settings",
                active: true
              }
            ]
          }
        },
        {
          path: "/transfers-pending",
          name: "transfers-pending",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          component: () => import("@/views/BackOffice/TransfersPending"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "rewards",
                active: true
              }
            ]
          }
        },
        {
          path: "/tickets-suports",
          name: "tickets-suports",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          component: () => import("@/views/BackOffice/TicketSuports"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "rewards",
                active: true
              }
            ]
          }
        },
        {
          path: "/convertions",
          name: "convertions",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          component: () => import("@/views/Conversions"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "convertions",
                active: true
              }
            ]
          }
        },
        {
          path: "/users",
          name: "users",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          component: () => import("@/views/Users"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "users",
                active: true
              }
            ]
          }
        },
        {
          path: "/users-create",
          name: "create_users",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "users"
              },
              {
                text: "create_users",
                active: true
              }
            ]
          },
          component: () => import("@/views/BackOffice/Users/create")
        },
        {
          path: "/users-edit/:id",
          name: "edit_users",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "users"
              },
              {
                text: "edit_users",
                active: true
              }
            ]
          },
          props: true,
          component: () => import("@/views/BackOffice/Users/edit")
        },
        {
          path: "/terms-and-conditions",
          name: "terms_and_conditions",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "terms_and_conditions"
              }
            ]
          },
          component: () => import("@/views/Conditions/app_term_condition")
        },
        {
          path: "/warehouses",
          name: "warehouses",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "warehouses"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Warehouses")
        },
        {
          path: "/inventory/create/:id/:type/:company",
          name: "create_inventory",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "create_inventory"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Inventory/create")
        },
        {
          path: "/inventory/show/:id",
          name: "inventory_show",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin;admin;member') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "inventory"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Inventory/show")
        },
        {
          path: "/history/transactions",
          name: "transactions",
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "transactions"
              }
            ]
          },
          component: () => import("@/views/Transactions")
        },

        {
          path: "/admin/words",
          name: "words",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "words"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Words")
        },
        {
          path: "/admin/words/counts",
          name: "words-count",
          async beforeEnter (to, from, next) {
            return helpers.can('super_admin') ? next() : next('/dashboard')
          },
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "exchange"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Fees")
        },
        {
          path: "/advertising-service",
          name: "advertising-service",
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "advertising-service"
              }
            ]
          },
          component: () => import("@/views/BackOffice/Advertising")
        },
        {
          path: "/advertising",
          name: "advertising",
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "advertising"
              }
            ]
          },
          component: () => import("@/views/BackOffice/AdvertisingService")
        },
        {
          path: "/coupons",
          name: "coupons",
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                text: "coupons"
              }
            ]
          },
          component: () => import("@/views/Coupons")
        },
      ]
    },
    {
      path: "",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Auth/Login.vue")
        },
        {
          path: "/register:ref?",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Auth/Register.vue")
        },
        {
          path: "/forgot-password",
          name: "forgot_password",
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Auth/ForgotPassword.vue")
        },
        {
          path: "/restore-password/:token",
          name: "restore_password",
          component: () =>
            import(/* webpackChunkName: "demo" */ "@/views/Auth/RestorePassword.vue")
        }
      ]
    },
    {
      path: '*',
      redirect: '/dashboard'
    },
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  const user = await check(to, from, next);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters["check"] &&  to.path !== "/login") {
      if (!user && to.path === "/register") {
        return next();
      }
      if (!user && to.name === "referrals") {
        if(to.params.ref){
          localStorage.setItem("ref", to.params.ref);
          router.push({ name: "register" });
        }
      } else if (!user) {
        next("/login");
      }
    } else if (store.getters["check"] && to.path === "/login") {
      router.push({ name: "dashboard" });
    } else {
      next();
    }
  } else if (store.getters["check"] && to.path === "/login") {
    router.push({ name: "dashboard" });
  } else {
    return next();
  }
});
router.afterEach((to, from) => {
  NProgress.done()
})

export default router;
